module.exports = __webpack_public_path__ + "static/media/4_lavallinen_kuorma_auto_b.f0eb7a13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/4_lavallinen_kuorma_auto_b.svg
// module id = 1165
// module chunks = 0